export var ReceiptStatus;
(function (ReceiptStatus) {
    ReceiptStatus["Pending"] = "pending";
    ReceiptStatus["Sent"] = "sent";
    ReceiptStatus["Delivered"] = "delivered";
    ReceiptStatus["Read"] = "read";
})(ReceiptStatus || (ReceiptStatus = {}));
//# sourceMappingURL=receipt-status.const.js.map